import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

import { GridScoreboardBaseComponent } from '../scoreboard-base/grid-scoreboard-base.component';
import { DartsScoreboardHeaderComponent } from './darts-scoreboard-header.component';
import { SetGameScoreboardHeaderComponent } from './set-game-scoreboard-header.component';
import { SnookerScoreboardHeaderComponent } from './snooker-scoreboard-header.component';

@Component({
    selector: 'ms-grid-scoreboard-header',
    templateUrl: './grid-scoreboard-header.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [SetGameScoreboardHeaderComponent, SnookerScoreboardHeaderComponent, DartsScoreboardHeaderComponent],
})
export class GridEventScoreboardHeaderComponent extends GridScoreboardBaseComponent {
    @HostBinding('class') className = 'grid-event-scoreboard-header';
}
